export default __webpack_public_path__ + "static/media/logo-31-mac-hotels.b16cbfb4.png";